export const deviceStatusPageSize=100;
export const startDateLimit=89
export const commonHeaders = {
    // serialNumber: "S.No",
    ts: {header:"Timestamp",desc:""},
};